import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  Layout,
  Menu,
  Button,
  Typography,
  Space,
  theme,
} from 'antd';
import {
  DashboardOutlined,
  FileTextOutlined,
  CalendarOutlined,
  BarChartOutlined,
  TeamOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { authApi } from '../api/endpoints';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

const menuItems = [
  { key: '/dashboard', icon: <DashboardOutlined />, label: 'ダッシュボード' },
  { key: '/posts', icon: <FileTextOutlined />, label: '投稿管理' },
  { key: '/calendar', icon: <CalendarOutlined />, label: 'カレンダー' },
  { key: '/reports', icon: <BarChartOutlined />, label: 'レポート' },
  { key: '/clients', icon: <TeamOutlined />, label: 'マスター管理' },
];

const bottomNavItems = [
  { path: '/dashboard', label: 'ダッシュボード', icon: <DashboardOutlined /> },
  { path: '/posts', label: '投稿管理', icon: <FileTextOutlined /> },
  { path: '/calendar', label: 'カレンダー', icon: <CalendarOutlined /> },
];

const AppLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = theme.useToken();

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } finally {
      navigate('/login');
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="lg"
        onBreakpoint={(broken) => setCollapsed(broken)}
        style={{ background: token.colorBgContainer }}
      >
        <div style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: `1px solid ${token.colorBorderSecondary}`,
        }}>
          <Text strong style={{ fontSize: collapsed ? 14 : 18 }}>
            {collapsed ? 'DM' : 'DM Manager'}
          </Text>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
          style={{ borderRight: 0 }}
        />
      </Sider>
      <Layout>
        <Header style={{
          background: token.colorBgContainer,
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: `1px solid ${token.colorBorderSecondary}`,
        }}>
          <Button
            className="sidebar-toggle"
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />
          <Space>
            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={handleLogout}
            >
              ログアウト
            </Button>
          </Space>
        </Header>
        <Content style={{ margin: 24, minHeight: 280 }}>
          <Outlet />
        </Content>
        <div className="mobile-bottom-nav">
          {bottomNavItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            return (
              <Button
                key={item.path}
                type="text"
                icon={item.icon}
                onClick={() => navigate(item.path)}
                className={isActive ? 'nav-active' : undefined}
                style={isActive ? { color: token.colorPrimary } : undefined}
              >
                {item.label}
              </Button>
            );
          })}
        </div>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
